export default __webpack_public_path__ + "static/media/accessSupportMd.bb64b41d.png";